import {httpResource} from "@/resources/http.resource";
import store from "@/store/store";
import {IAccounts} from "@/modules/Profile/interfaces/accounts.interface";

export class AccountsResource {
  async getAccountsByCorp(payload: { corpId: number; fltEnabled: boolean; }) {
    let asyncAction = async () => {
      const action = IAccounts.Action.PersonsMk;
      const params: any = {
        command: IAccounts.Command.Get,
        ...payload,
      };
      const response = await httpResource.httpAction({ action, params });
      return response.data.result.persons;
    };
    const { response } = await store.dispatch('defaultResourceAction', { asyncAction });
    return response;
  }

  async createAccount(payload: IAccounts.ICreateAccountPayload) {
    let asyncAction = async () => {
      let action = IAccounts.Action.PersonsMk;
      let params = { command: IAccounts.Command.Create, ...payload };
      let response = await httpResource.httpAction({ action, params });
      return response.data.result;
    };
    return await store.dispatch('defaultResourceAction', { asyncAction, customErrorAction: true }, { root: true });
  }

  async updateAccount(payload: IAccounts.IUpdateAccountPayload) {
    let asyncAction = async () => {
      let action = IAccounts.Action.PersonsMk;
      let params = { command: IAccounts.Command.Update, ...payload };
      let response = await httpResource.httpAction({ action, params });
      return response.data.result;
    };
    return await store.dispatch('defaultResourceAction', { asyncAction }, { root: true });
  }
}

export const accountResource = new AccountsResource();